import React, { useState, useEffect } from 'react';

import TalkToSpecialistButton from './components/TalkToSpecialistButton.jsx';
import ScheduleMeetingButton from './components/ScheduleMeetingButton.jsx';

export default function WeezoLanding() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 20 - 10,
        y: (e.clientY / window.innerHeight) * 20 - 10
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 text-white overflow-hidden relative">
      
   
      <div className="absolute inset-0 overflow-hidden">
        <div 
          className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse"
          style={{
            transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
            transition: 'transform 0.3s ease-out'
          }}
        />
        <div 
          className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse"
          style={{
            transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)`,
            transition: 'transform 0.3s ease-out',
            animationDelay: '1s'
          }}
        />
      </div>

     
      <div className="relative z-10">

       
        <header className="sticky top-0 z-50 backdrop-blur-xl">
          <div 
            className="absolute inset-0 bg-white/50 pointer-events-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' ... %3C/svg%3E")`,
              backgroundSize: '250px 250px'
            }}
          />
          <div className="relative container mx-auto px-6 py-3 flex justify-between items-center border-b border-white/10">
            <div className="flex items-center gap-3">
              <div className="w-28 h-8 rounded flex items-center justify-center">
                <img src="/1_logo_referencia.png" alt="Weezo" />
              </div>
            </div>

            <div className="text-xs px-3 py-1.5 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 text-blue-500 font-light">
              Consultoria de Software
            </div>
          </div>
        </header>

      
        <main className="container mx-auto px-6 pt-20 pb-32">
          <div 
            className={`max-w-5xl mx-auto text-center transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >

           
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 backdrop-blur-sm border border-blue-500/20 rounded-full mb-8">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" />
              <span className="text-sm text-blue-300">Consultoria de Software</span>
            </div>

           
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              Transforme suas ideias em software
              <br />
              <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
                com velocidade e precisão
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 mb-16 max-w-3xl mx-auto">
              Na Weezo, conectamos sua empresa aos especialistas certos — do recrutamento à entrega do produto.
            </p>

          
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <TalkToSpecialistButton onClick={() => console.log("Fale com um especialista clicado")} />
            </div>
          </div>

        
<div
  className={`max-w-6xl mx-auto mt-32 transition-all duration-1000 delay-200 ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}
>
  <div className="text-center mb-16">
    <h2 className="text-4xl md:text-5xl font-bold mb-6">
      Aceleramos o desenvolvimento de software da sua empresa
    </h2>
    <p className="text-lg text-slate-300 max-w-3xl mx-auto">
      Cada projeto tem desafios únicos. A Weezo atua como uma extensão do seu time,
      ajudando sua empresa a montar a equipe certa, destravar gargalos técnicos e
      garantir que as soluções sejam entregues dentro do prazo e do orçamento.
    </p>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {[
      {
        title: 'Recrutamento técnico especializado',
        description:
          'Encontramos profissionais com o perfil exato que seu projeto precisa — desenvolvedores, arquitetos, product managers e mais.',
        gradient: 'from-blue-500 to-cyan-500',
      },
      {
        title: 'Montagem de times sob medida',
        description:
          'Formamos equipes completas e multidisciplinares prontas para iniciar o desenvolvimento imediatamente.',
        gradient: 'from-cyan-500 to-blue-500',
      },
      {
        title: 'Consultoria técnica e estratégica',
        description:
          'Especialistas avaliam o escopo, definem tecnologias, estimam custos e ajudam a garantir a viabilidade do projeto.',
        gradient: 'from-blue-500 to-purple-500',
      },
    ].map((card, index) => (
      <div
        key={index}
        className="group relative p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-white/20 transition-all duration-300 hover:scale-105"
      >
        <div
          className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}
        />
        <div
          className={`w-12 h-1 bg-gradient-to-r ${card.gradient} rounded-full mb-4`}
        />
        <h3 className="text-xl font-bold mb-3">{card.title}</h3>
        <p className="text-slate-400">{card.description}</p>
      </div>
    ))}
  </div>
</div>


<div
  className={`grid grid-cols-1 md:grid-cols-3 gap-6 mt-32 max-w-6xl mx-auto transition-all duration-1000 delay-300 ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}
>
  <div className="md:col-span-3 text-center mb-12">
    <h2 className="text-4xl md:text-5xl font-bold mb-6">
      Expertise que entrega resultados
    </h2>
  </div>

  {[
    {
      title: 'Profissionais experientes',
      description: 'Especialistas com experiência em grandes projetos de tecnologia',
      gradient: 'from-blue-500 to-cyan-500',
    },
    {
      title: 'Agilidade comprovada',
      description: 'Redução de tempo de contratação e ramp-up de equipes',
      gradient: 'from-cyan-500 to-blue-500',
    },
    {
      title: 'Entregas no prazo e orçamento',
      description: 'Acompanhamento técnico contínuo durante todo o ciclo de desenvolvimento',
      gradient: 'from-blue-500 to-purple-500',
    },
  ].map((card, index) => (
    <div
      key={index}
      className="group relative p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-white/20 transition-all duration-300 hover:scale-105"
    >
      <div
        className={`absolute inset-0 bg-gradient-to-br ${card.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}
      />
      <div
        className={`w-12 h-1 bg-gradient-to-r ${card.gradient} rounded-full mb-4`}
      />
      <h3 className="text-2xl font-bold mb-3">{card.title}</h3>
      <p className="text-slate-400">{card.description}</p>
    </div>
  ))}
</div>


<div
  className={`max-w-6xl mx-auto mt-32 transition-all duration-1000 delay-400 ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}
>
  <div className="text-center mb-16">
    <h2 className="text-4xl md:text-5xl font-bold mb-12">
      Empresas que aceleraram com a Weezo
    </h2>
    <div className="flex flex-wrap gap-8 items-center justify-center">
      {[
        { name: 'BluevecHub', url: 'https://www.bluevechub.com/' },
        { name: 'RRC Robótica', url: 'https://www.rrcrobotica.com.br/' },
        { name: 'We Are Meta', url: 'https://www.wearemeta.io/' },
      ].map(
        (company, index) => (
          <div
            key={index}
            className="p-6 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:border-white/20 transition-all duration-300 hover:scale-105"
          >
            {company.url ? (
              <a 
                href={company.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-lg font-bold text-slate-300 hover:text-white transition-colors"
              >
                {company.name}
              </a>
            ) : (
              <div className="text-lg font-bold text-slate-300">{company.name}</div>
            )}
          </div>
        )
      )}
    </div>
  </div>
</div>


{/* <div
  className={`max-w-6xl mx-auto mt-32 transition-all duration-1000 delay-500 ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
  }`}
>
  <div className="text-center mb-16">
    <h2 className="text-4xl md:text-5xl font-bold mb-12">
      O que nossos clientes dizem
    </h2>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    {[
      {
        text: 'A Weezo nos ajudou a montar uma equipe de desenvolvimento em tempo recorde. O projeto que estava parado há meses finalmente saiu do papel.',
        author: 'Carla Menezes',
        role: 'CTO da FinnoPay',
      },
      {
        text: 'Com a consultoria da Weezo, conseguimos reduzir 30% do custo do nosso novo sistema sem comprometer a qualidade. Excelente parceria!',
        author: 'Rafael Duarte',
        role: 'Diretor de Tecnologia da AgroLink',
      },
      {
        text: 'O time da Weezo entendeu exatamente o que precisávamos e trouxe profissionais incríveis. Hoje nosso produto está crescendo muito mais rápido.',
        author: 'Mariana Lopes',
        role: 'Head de Produto da VivaMais Saúde',
      },
    ].map((testimonial, index) => (
      <div
        key={index}
        className="group relative p-8 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-white/20 transition-all duration-300 hover:scale-105"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 to-cyan-500/10 opacity-0 group-hover:opacity-100 rounded-2xl transition-opacity duration-300" />
        <div className="relative">
          <p className="text-slate-300 mb-6 italic">"{testimonial.text}"</p>
          <div className="border-t border-white/10 pt-4">
            <p className="font-bold text-white">{testimonial.author}</p>
            <p className="text-sm text-slate-400">{testimonial.role}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div> */}

          
          <div 
            className={`max-w-4xl mx-auto mt-32 text-center transition-all duration-1000 delay-600 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="relative p-12 bg-gradient-to-br from-blue-600/20 to-cyan-600/20 backdrop-blur-sm rounded-3xl border border-white/20">

              <div className="relative">
                <h2 className="text-4xl md:text-5xl font-bold mb-6">
                  Pronto para tirar seu projeto do papel?
                </h2>

                <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
                  Fale com um especialista Weezo e descubra como acelerar o seu desenvolvimento.
                </p>

                
                <ScheduleMeetingButton onClick={() => console.log("Agendar conversa clicado")} />

              </div>
            </div>
          </div>

        </main>

        
        <footer className="container mx-auto px-6 py-12 border-t border-white/10 mt-32">
  <div className="max-w-6xl mx-auto">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
      <div>
        <img
          src="/3b_logo_simplificado_negativo.png"
          alt="Weezo"
          className="h-8 mb-4"
        />
        <p className="text-slate-400 text-sm">
          Consultoria de Software especializada em conectar empresas aos melhores
          talentos tech.
        </p>
      </div>

      <div>
        <h4 className="font-bold mb-4">Contato</h4>
        <p className="text-slate-400 text-sm mb-2">contato@weezo.com.br</p>
        <p className="text-slate-400 text-sm">
          LinkedIn: <a 
            href="https://www.linkedin.com/company/weezotech/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-white transition-colors"
          >
            /company/weezotech
          </a>
        </p>
      </div>

      {/* <div>
        <h4 className="font-bold mb-4">Legal</h4>
        <a
          href="#"
          className="text-slate-400 text-sm hover:text-white transition-colors block mb-2"
        >
          Política de Privacidade
        </a>
        <a
          href="#"
          className="text-slate-400 text-sm hover:text-white transition-colors block"
        >
          Termos de Uso
        </a>
      </div> */}
    </div>

    <div className="text-center text-sm text-slate-400 pt-8 border-t border-white/10">
      © {new Date().getFullYear()} Weezo. Todos os direitos reservados.
    </div>
  </div>
        </footer>

      </div>

      
      <div className="absolute top-1/2 left-0 w-px h-32 bg-gradient-to-b from-transparent via-blue-500/50 to-transparent" />
      <div className="absolute top-1/2 right-0 w-px h-32 bg-gradient-to-b from-transparent via-cyan-500/50 to-transparent" />
    </div>
  );
}
